import { Outlet } from "react-router-dom";
import DemoBanner from "@/components/DemoBanner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-ivory">
      <DemoBanner />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
